import { menusApi } from "@src/service/menus";
import { getRequestError } from "@src/utils/getRequestError";
import { call, put, select, takeLatest } from "redux-saga/effects";
import { setGlobalLoader, setSnackbar } from "../generals/actionCreators";
import { LoadingStatus } from "../generals/types";
import {
  clearMenuList,
  fetchMenuList,
  publicationMenuAction,
  fetchMenuListAction,
  fetchPublicationMenuCountAction,
  fetchMenuPublicationCount,
  fetchMenuPublicationCountSuccess,
  uploadJsonFileAction,
  createPosMenuAction,
  requestYandexPublicationAction,
  setIsFetching,
} from "./actionCreators";
import { MenuListActionTypes } from "./types/actionTypes";

export function* fetchMenuListRequest(action: fetchMenuListAction) {
  try {
    yield put(setGlobalLoader(LoadingStatus.LOADING));

    let query = action.payload || "page=1&field=date";
    const { currLocation } = yield select((store) => store.appManager);

    const { data } = yield call(menusApi.getMenusList, currLocation, query);
    yield put({
      type: MenuListActionTypes.FETCH_MENU_LIST_SUCCESS,
      payload: data,
    });
    yield put(fetchMenuPublicationCount());
    yield put(setGlobalLoader(LoadingStatus.SUCCESS));
  } catch (e) {
    yield put(clearMenuList());
    yield put(setGlobalLoader(LoadingStatus.ERROR));
    yield put(
      setSnackbar({
        status: "error",
        message: getRequestError(e),
        visible: true,
      })
    );
  }
}

export function* uploadMenuRequest(action: publicationMenuAction) {
  try {
    yield put(setGlobalLoader(LoadingStatus.LOADING));
    yield call(menusApi.uploadMenu, action.payload);
    // const { menu_id } = action.payload[0];
    // yield put(updateAllStopLists(menu_id));
    yield put(
      setSnackbar({ status: "success", message: "Publicated", visible: true })
    );
    yield put(fetchMenuPublicationCount());
    yield put(setGlobalLoader(LoadingStatus.SUCCESS));
    yield put(fetchMenuList(""));
  } catch (e) {
    yield put(setGlobalLoader(LoadingStatus.ERROR));
    yield put(
      setSnackbar({
        status: "error",
        message: getRequestError(e),
        visible: true,
      })
    );
  }
}

export function* fetchPublicationMenuCountRequest(
  action: fetchPublicationMenuCountAction
) {
  try {
    const { currLocation } = yield select((store) => store.appManager);
    const { data } = yield call(menusApi.getMenuPublicationCount, currLocation);
    yield put(fetchMenuPublicationCountSuccess(data.available_uploads));
  } catch (e) {
    yield put(
      setSnackbar({
        status: "error",
        message: getRequestError(e),
        visible: true,
      })
    );
  }
}

export function* updateMenuRequest() {
  try {
    yield put(setIsFetching(true));
    
    const { currLocation } = yield select((store) => store.appManager);
    yield call(menusApi.updateMenu, currLocation);
    yield put(
      setSnackbar({
        status: "success",
        message: "Menu Updated Success",
        visible: true,
      })
    );
  } catch (e) {
    yield put(
      setSnackbar({
        status: "error",
        message: getRequestError(e),
        visible: true,
      })
    );
  }
  finally {
    yield put(setIsFetching(false));
  }
}

export function* autoUpdateMenuRequest(action: any) {
  try {
    const { menuID, body } = action.payload;
    const { currLocation } = yield select((store) => store.appManager);
    yield call(menusApi.autoUpdateMenu, menuID, currLocation, body);
    yield put(
      setSnackbar({
        status: "success",
        message: "Auto update menu success",
        visible: true,
      })
    );
  } catch (e) {
    yield put(
      setSnackbar({
        status: "error",
        message: getRequestError(e),
        visible: true,
      })
    );
  }
}

export function* updateMoyskladMenuRequest() {
  try {
    yield put(setGlobalLoader(LoadingStatus.LOADING));
    const { currLocation } = yield select((store) => store.appManager);
    yield call(menusApi.updateMoyskladMenu, currLocation);
    yield put(
      setSnackbar({
        status: "success",
        message: "Moysklad Menu Updated Success",
        visible: true,
      })
    );
    yield put(setGlobalLoader(LoadingStatus.SUCCESS));
  } catch (e) {
    yield put(setGlobalLoader(LoadingStatus.ERROR));
    yield put(
      setSnackbar({
        status: "error",
        message: getRequestError(e),
        visible: true,
      })
    );
  }
}

export function* deleteMenuRequest(action: any) {
  try {
    yield put(setGlobalLoader(LoadingStatus.LOADING));
    const { menuId } = action.payload;
    const { currLocation } = yield select((store) => store.appManager);
    yield call(menusApi.deleteMenu, menuId, currLocation);
    yield put(fetchMenuList(""));
    yield put(setGlobalLoader(LoadingStatus.SUCCESS));
    yield put(
      setSnackbar({
        visible: true,
        message: "Menu deleted successfull",
        status: "success",
      })
    );
  } catch (e: any) {
    yield put(setGlobalLoader(LoadingStatus.ERROR));
    yield put(
      setSnackbar({
        visible: true,
        message: getRequestError(e),
        status: "error",
      })
    );
  }
}

export function* recoveryMenuRequest(action: any) {
  try {
    yield put(setGlobalLoader(LoadingStatus.LOADING));

    const { menuId, restaurantId } = action.payload;

    yield call(menusApi.recoveryMenu, menuId, restaurantId);
    yield put(setGlobalLoader(LoadingStatus.SUCCESS));
  } catch (e) {
    yield put(setGlobalLoader(LoadingStatus.ERROR));

    yield put(
      setSnackbar({
        visible: true,
        message: getRequestError(e),
        status: "error",
      })
    );
  }
}

export function* requestYandexPublication(
  action: requestYandexPublicationAction
) {
  try {
    yield put(setGlobalLoader(LoadingStatus.LOADING));

    const { restaurantId, groupId } = action.payload;

    yield call(menusApi.requestYandexPublication, restaurantId, groupId);

    yield put(setGlobalLoader(LoadingStatus.SUCCESS));
    yield put(
      setSnackbar({
        visible: true,
        message: "Success! Yandex publication requested",
        status: "success",
      })
    );
  } catch (e) {
    yield put(setGlobalLoader(LoadingStatus.ERROR));

    yield put(
      setSnackbar({
        visible: true,
        message: getRequestError(e),
        status: "error",
      })
    );
  }
}

export function* fetchJsonFileRequest(action: fetchMenuListAction) {
  try {
    yield put(setGlobalLoader(LoadingStatus.LOADING));

    const { data } = yield call(menusApi.getJsonFile, action.payload);

    const jsonString = `data:text/json;chatset=utf-8,${encodeURIComponent(
      JSON.stringify(data)
    )}`;
    const link = document.createElement("a");
    link.href = jsonString;
    link.download = "data.json";
    link.click();

    yield put(setGlobalLoader(LoadingStatus.SUCCESS));
  } catch (e) {
    yield put(setGlobalLoader(LoadingStatus.ERROR));
    yield put(
      setSnackbar({
        visible: true,
        message: getRequestError(e),
        status: "error",
      })
    );
  }
}

export function* uploadJsonFileRequest(action: uploadJsonFileAction) {
  try {
    yield put(setGlobalLoader(LoadingStatus.LOADING));

    yield call(
      menusApi.uploadJsonFile,
      action.payload.menuId,
      {
        menu: action.payload.file,
      },
      action.payload.delivery_service
    );

    yield put(setGlobalLoader(LoadingStatus.SUCCESS));
  } catch (e) {
    yield put(setGlobalLoader(LoadingStatus.ERROR));
    yield put(
      setSnackbar({
        visible: true,
        message: getRequestError(e),
        status: "error",
      })
    );
  }
}

export function* createPosMenuRequest(action: createPosMenuAction) {
  try {
    const { currLocation } = yield select((store) => store.appManager);
    yield call(menusApi.createPosMenu, currLocation, action.payload.aggregator);

    yield put(fetchMenuList(""));
  } catch (e) {
    yield put(
      setSnackbar({
        visible: true,
        message: getRequestError(e),
        status: "error",
      })
    );
  }
}

export function* menusListSaga() {
  yield takeLatest(
    MenuListActionTypes.FETCH_MENU_LIST_SAGA,
    fetchMenuListRequest
  );

  yield takeLatest(
    MenuListActionTypes.PUBLICATION_MENU_SAGA,
    uploadMenuRequest
  );

  yield takeLatest(
    MenuListActionTypes.FETCH_PUBLICATION_COUNT_SAGA,
    fetchPublicationMenuCountRequest
  );

  yield takeLatest(
    MenuListActionTypes.UPDATE_MOYSKLAD_MENU_SAGA,
    updateMoyskladMenuRequest
  );

  yield takeLatest(
    MenuListActionTypes.FETCH_JSON_FILE_SAGA,
    fetchJsonFileRequest
  );

  yield takeLatest(
    MenuListActionTypes.UPLOAD_JSON_FILE_SAGA,
    uploadJsonFileRequest
  );

  yield takeLatest(
    MenuListActionTypes.CREATE_POS_MENU_SAGA,
    createPosMenuRequest
  );

  yield takeLatest(MenuListActionTypes.RECOVERY_MENU_SAGA, recoveryMenuRequest);
  yield takeLatest(MenuListActionTypes.DELETE_MENU_SAGA, deleteMenuRequest);
  yield takeLatest(MenuListActionTypes.UPDATE_MENU_SAGA, updateMenuRequest);
  yield takeLatest(
    MenuListActionTypes.AUTO_UPDATE_MENU_SAGA,
    autoUpdateMenuRequest
  );
  yield takeLatest(
    MenuListActionTypes.REQUEST_YANDEX_PUBLICATION_SAGA,
    requestYandexPublication
  );
}
